// Copyright (c) 2016 Deere & Company

import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const updateCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().customer, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_CUSTOMER_DETAILS]: updateCustomer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/customer.js